import axios from "axios";
import { BaseService, sipondApiToken, sipondBaseURL } from "./base.service";
import {
  BillsAndBalancesResponse,
  MadingResponse,
  SlidersResponse,
} from "./dtos/home.dto";

interface HomeServiceInterface {
  queries: {
    GET_SLIDER: string;
    GET_MADING: string;
    GET_BILLS_AND_BALANCES: string;
  };
  sliders(): Promise<SlidersResponse>;
  mading(kategori: string, limit: string): Promise<MadingResponse>;
  billsAndBalances(payload: { nis: string }): Promise<BillsAndBalancesResponse>;
}
export const HomeService: HomeServiceInterface = {
  queries: {
    GET_SLIDER: "GET_SLIDER",
    GET_MADING: "GET_MADING",
    GET_BILLS_AND_BALANCES: "GET_BILLS_AND_BALANCES",
  },

  sliders: async () => {
    try {
      const request = await BaseService.request().get<SlidersResponse>(
        "/home/sliders"
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  mading: async (kategori: string, limit: string) => {
    try {
      const request = await axios.get<MadingResponse>(
        `${sipondBaseURL}/api/admin/mading-slider/${kategori}/${limit}`,
        {
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  billsAndBalances: async (payload: { nis: string }) => {
    try {
      const request = await axios.get<BillsAndBalancesResponse>(
        `${sipondBaseURL}/api/orangtua/balance`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
};
